import { createSlice } from "@reduxjs/toolkit";
import { eventPackagesAllAction, eventPackagesListAction } from "../Actions/eventPackages";

const initialState = {
    packageList: [],
    packageAllList: []
}

const EventPackageSlice = createSlice({
    name: "eventPackage",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(eventPackagesListAction.fulfilled, (state, { payload }) => {
            if (payload?.statusCode === 200) {
                state.packageList = payload.data;
            }
        })
        builder.addCase(eventPackagesAllAction.fulfilled, (state, { payload }) => {
            if (payload?.statusCode === 200) {
                state.packageAllList = payload.data;
            }
        })
    },
});

export default EventPackageSlice.reducer;
